"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTransformationToolsRestriction = exports.isDrawingRestriction = exports.isDraggingRestriction = exports.RESTRICTION_TYPE = void 0;
var RESTRICTION_TYPE;
(function (RESTRICTION_TYPE) {
    RESTRICTION_TYPE["PLANE"] = "plane";
    RESTRICTION_TYPE["GEOMETRY"] = "geometry";
    RESTRICTION_TYPE["POINT"] = "point";
    RESTRICTION_TYPE["LINE"] = "line";
    RESTRICTION_TYPE["CAMERA_PLANE"] = "camera_plane";
})(RESTRICTION_TYPE || (exports.RESTRICTION_TYPE = RESTRICTION_TYPE = {}));
const isDraggingRestriction = (metaData) => {
    return (metaData === null || metaData === void 0 ? void 0 : metaData.type) === "dragging";
};
exports.isDraggingRestriction = isDraggingRestriction;
const isDrawingRestriction = (metaData) => {
    return (metaData === null || metaData === void 0 ? void 0 : metaData.type) === "drawing";
};
exports.isDrawingRestriction = isDrawingRestriction;
const isTransformationToolsRestriction = (metaData) => {
    return (metaData === null || metaData === void 0 ? void 0 : metaData.type) === "transformation-tools";
};
exports.isTransformationToolsRestriction = isTransformationToolsRestriction;
//# sourceMappingURL=IRestriction.js.map